<template>
  <div>
    <div class="d-flex flex-column align-center mb-2">
      <v-img :src="require('@/assets/telegram-icon.png')" height="140px" contain />
      <h2>Telegram</h2>
    </div>

    <p v-if="!isConnected">Sign in to connect your account to Telegram</p>
    <div class="d-flex justify-center py-8">
      <div v-if="!isConnected">
        <TelegramSignInButton v-if="!telegramAuth" @input="handleLinkTelegram"/>
        <p v-else>Telegram account connected</p>
      </div>

      <div v-else>
        <p class="text-center px-3">You have already connected a Telegram account</p>
      </div>
    </div>

    <div class="mt-4 d-flex pb-2 justify-center">
      <v-btn
        text
        :color="isConnected ? 'primary' : 'grey'"
        @click="handleNext"
      >
        {{ isConnected ? 'Continue To Main Page' : 'Maybe Later (Skip)' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import TelegramSignInButton from "@/core/components/core/TelegramSignInButton";
import {connectUserTelegram, usersCollection} from "@/core/config/firebase";

export default {
  name: 'ConnectTelegram',
  components: {
    TelegramSignInButton
  },
  data () {
    return {
      telegramAuth: null,
      isConnected: false
    }
  },
  computed: {
    ...mapGetters('user', ['getUserProfile', 'getCurrentUser']),
  },
  watch: {
    getCurrentUser(){
      this.checkTelegramAuth();
    }
  },
  methods: {
    handleNext() {
      this.$router.push({ name: "Home" })
    },
    async checkTelegramAuth() {
      if(!this.getCurrentUser) {
        return
      }

      const doc = await usersCollection
        .doc(this.getCurrentUser.uid)
        .collection("private")
        .doc("telegramAuth")
        .get()
      this.isConnected = doc.exists;
    },
    async handleLinkTelegram(auth) {
      if (auth) {
        this.telegramAuth = auth;
        await connectUserTelegram(auth);
        this.checkTelegramAuth();
      }
    },
  },
  mounted() {
    this.checkTelegramAuth();
  }
}
</script>
<style>

</style>
